<template>

    <div class="bg-white row items-center full-width" :style="{'border-top': '5px solid '+iconAndBoder}">
        <div class="col-auto" v-if="icon">
            <div class="q-px-md q-py-sm">
                <div class="row circle column-icon justify-center items-center"
                     :style="{ 'border': '3px solid '+ iconAndBoder, width: '60px', height:'60px'}">
                    <q-icon :name="icon || 'list'" size="2rem" :style="{ color:iconAndBoder  }"></q-icon>
                </div>
            </div>
        </div>
        <div class="col q-title" style="color: #5d5d62; letter-spacing: 0.25rem; text-transform:uppercase;
            font-size: 16px; font-weight: bold;">
            {{ title | capitalize }}
        </div>
        <div class="col-auto" v-if="$slots.right">
            <div class="q-px-md q-py-sm no-wrap row items-center">
                <slot name="right"></slot>
            </div>
        </div>
    </div>

</template>


<script>
    import {QIcon} from 'quasar-framework'

    export default {
        name: 'VHeader',

        props: {
            title: String,
            titleColor: {
                type: String,
                default: 'highlight'
            },
            icon: String,

            iconAndBoder: {
                type: String,
                default: '#f29a38'
            }
        },

        components: {
            QIcon
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Header.vue